import { formatLabel } from '@/utils/finance';

const INVOICE: Record<string, string> = {
  pending: 'bg-amber-100 text-amber-800',
  unpaid: 'bg-amber-100 text-amber-800',
  partially_paid: 'bg-blue-100 text-blue-800',
  paid: 'bg-green-100 text-green-800',
  overdue: 'bg-red-100 text-red-800',
  cancelled: 'bg-gray-100 text-gray-700',
};

const EXPENSE: Record<string, string> = {
  draft: 'bg-gray-100 text-gray-700',
  pending_approval: 'bg-amber-100 text-amber-800',
  rejected: 'bg-red-100 text-red-800',
  approved: 'bg-indigo-100 text-indigo-800',
  partially_paid: 'bg-blue-100 text-blue-800',
  paid: 'bg-green-100 text-green-800',
};

const LABELS: Record<string, string> = {
  pending: 'Unpaid',
  approved: 'Approved · Pending payment',
  pending_approval: 'Pending approval',
};

export default function StatusBadge({ status, kind }: { status: string; kind: 'invoice' | 'expense' }) {
  const palette = kind === 'invoice' ? INVOICE : EXPENSE;

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${palette[status] ?? 'bg-gray-100 text-gray-700'}`}>
      {LABELS[status] ?? formatLabel(status)}
    </span>
  );
}
